import { makeupV3PresetThumbUrl } from '../utils/makeupV3PresetThumbs';
import { MAKEUP_V3_EVERYDAY_PRESETS, presetV3SwatchBackground } from '../utils/makeupFluxV3TimePresets';

export default function MakeupV3EverydayPresetsRail({
  selectedPresetId,
  onSelectPreset,
  disabled = false,
  className = 'makeup-v3-kiosk-presets looks-preset-rail looks-preset-rail--kiosk',
  presets = null,
}) {
  const list = presets || MAKEUP_V3_EVERYDAY_PRESETS;
  return (
    <div className={className} role="list">
      {list.map((preset) => {
        const thumb = makeupV3PresetThumbUrl(preset.id);
        return (
          <button
            key={preset.id}
            type="button"
            role="listitem"
            className={`looks-preset-card${
              selectedPresetId === preset.id ? ' is-selected is-applied' : ''
            }`}
            disabled={disabled}
            onClick={() => onSelectPreset(preset.id)}
            aria-label={preset.label}
            aria-pressed={selectedPresetId === preset.id}
          >
            {thumb ? (
              <img
                src={thumb}
                alt=""
                className="looks-preset-card__thumb"
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
            ) : null}
            <div
              className="looks-preset-card__swatch looks-preset-card__swatch--v3"
              style={{ background: presetV3SwatchBackground(preset) }}
              aria-hidden="true"
            />
            <strong className="looks-preset-card__name">{preset.label}</strong>
          </button>
        );
      })}
    </div>
  );
}
